// Selected tax year sent to the backend as the `tax-year` header on every API call
// (Parquet requirements CO-13, FR-19.8). PartnershipContext owns the selection and keeps this
// holder in sync synchronously, so requests fired from child effects on first render already
// carry it; ApiService's request interceptor reads it.

export const TAX_YEAR_HEADER = "tax-year";

let currentTaxYear: string | null = null;

export const setCurrentTaxYear = (taxYear: string | null): void => {
  currentTaxYear = taxYear;
};

export const getCurrentTaxYear = (): string | null => currentTaxYear;
